/*
 * @Author: huangzq
 * @Date: 2019-10-20 23:01:53
 * @Last Modified by: huangzq
 * @Last Modified time: 2019-10-20 23:04:17
 * @Desc: Storage的相关操作
 */
// storage.getItem
const getItem = (key: string, storage = window.sessionStorage) => {
  const data = JSON.parse(storage.getItem(key) || 'null');
  return data;

};

// storage.setItem
const setItem = (key: any, value: any, storage = window.sessionStorage) => {
  storage.setItem(key, JSON.stringify(value));
};

// storage.removeItem
const removeItem = (key: string, storage = window.sessionStorage) => {
  storage.removeItem(key);
};

export default { getItem, setItem, removeItem };
